import { SECTION_KEY_TO_FILTERS_FIELD } from './filterHelpers';

function toggleInArray(arr, value) {
  const list = Array.isArray(arr) ? arr : [];
  const str = String(value);
  return list.includes(str) ? list.filter((x) => String(x) !== str) : [...list, str];
}

export function toggleFiltersByOptionKey(currentFilters, optionKey) {
  const [sectionKey, key] = String(optionKey).split(':');
  if (!sectionKey || !key) return currentFilters ?? {};

  const arrayKey = SECTION_KEY_TO_FILTERS_FIELD[sectionKey];
  if (arrayKey == null) {
    return currentFilters ?? {};
  }

  const base = currentFilters ?? {};
  return {
    ...base,
    [arrayKey]: toggleInArray(base[arrayKey], key),
  };
}
